import { useState } from "react";

const CostsCard = ({ label, amount = 0, currency = "RON", subtitle, icon, variant = "default", formatCurrency, budget }) => {
  const [hovered, setHovered] = useState(false);

  const fmt = (value) =>
    formatCurrency
      ? formatCurrency(value, currency, false, false)
      : `${(value || 0).toLocaleString("en-US", { minimumFractionDigits: 2 })} ${currency}`;

  const budgetProgress = (() => {
    if (!budget || budget <= 0) return null;
    const pct = (amount / budget) * 100;
    const barColor = pct > 100 ? "#ef4444" : pct > 80 ? "#f59e0b" : "#34d399";
    return { pct, barColor };
  })();

  const renderAmounts = (primaryColor, secondaryColor) => (
    <>
      <p style={{ fontSize: "1.75rem", fontWeight: 800, color: primaryColor, letterSpacing: "-0.03em", marginBottom: 2, lineHeight: 1.1 }}>
        {fmt(amount)}
      </p>
      {budgetProgress && (
        <div style={{ marginTop: 10 }}>
          <div style={{ display: "flex", justifyContent: "space-between", fontSize: "0.65rem", color: secondaryColor, marginBottom: 3, opacity: 0.8 }}>
            <span>{Math.round(budgetProgress.pct)}% of budget</span>
            <span>{fmt(budget)}</span>
          </div>
          <div style={{ height: 4, borderRadius: 2, background: "rgba(0,0,0,0.1)", overflow: "hidden" }}>
            <div style={{
              height: "100%",
              width: `${Math.min(budgetProgress.pct, 100)}%`,
              background: budgetProgress.barColor,
              borderRadius: 2,
              transition: "width 0.3s ease",
            }} />
          </div>
        </div>
      )}
    </>
  );

  if (variant === "primary") {
    return (
      <div
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        style={{ background: "linear-gradient(135deg, #002045 0%, #1a365d 100%)", borderRadius: 16, padding: 24, boxShadow: hovered ? "0 16px 40px rgba(0, 32, 69, 0.3)" : "0 8px 30px rgba(0, 32, 69, 0.15)", display: "flex", flexDirection: "column", justifyContent: "space-between", position: "relative", overflow: "hidden", minHeight: 140, transform: hovered ? "translateY(-4px)" : "translateY(0)", transition: "transform 0.2s ease, box-shadow 0.2s ease", zIndex: hovered ? 2 : 1 }}
      >
        <i className="ri-bar-chart-2-fill" style={{ position: "absolute", right: -16, bottom: -16, fontSize: 120, color: "white", opacity: 0.1 }} />
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16, position: "relative", zIndex: 1 }}>
          <span style={{ fontSize: "0.6rem", fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.15em", color: "#adc7f7" }}>
            {label}
          </span>
          <i className="ri-money-dollar-circle-line" style={{ fontSize: 18, color: "#adc7f7" }} />
        </div>
        <div style={{ position: "relative", zIndex: 1 }}>
          {renderAmounts("white", "#adc7f7")}
          <p style={{ fontSize: "0.75rem", color: "#adc7f7", fontWeight: 500, margin: 0, marginTop: 6 }}>{subtitle}</p>
        </div>
      </div>
    );
  }

  return (
    <div
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{ background: "white", borderRadius: 16, padding: 24, boxShadow: hovered ? "0 12px 32px -4px rgba(0, 0, 0, 0.12)" : "0 4px 20px -4px rgba(0, 0, 0, 0.05)", border: hovered ? "1px solid rgba(0, 32, 69, 0.15)" : "1px solid #f0f4ff", display: "flex", flexDirection: "column", justifyContent: "space-between", minHeight: 140, transform: hovered ? "translateY(-4px)" : "translateY(0)", transition: "transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease", zIndex: hovered ? 2 : 1 }}
    >
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16 }}>
        <span style={{ fontSize: "0.6rem", fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.15em", color: "#6b7280", opacity: 0.9 }}>
          {label}
        </span>
      </div>
      <div>
        {renderAmounts("#002045", "#6b7280")}
        {subtitle && (
          <div style={{ display: "flex", alignItems: "center", gap: 8, marginTop: 6 }}>
            <span style={{ width: 8, height: 8, borderRadius: "50%", background: "#34d399", flexShrink: 0 }} />
            <p style={{ fontSize: "0.75rem", color: "#6b7280", fontWeight: 500, margin: 0 }}>{subtitle}</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default CostsCard;
